<template>
    <div class="cap-body">
        <DxDataGrid :data-source="ds" ref="gridRef" key-expr="Id" :show-borders="true" height="100%"
            :row-alternation-enabled="true" :hover-state-enabled="true"
            no-data-text="Nu există componente de sumă pentru angajatul selectat."
            @context-menu-preparing="onContextMenu">
            <DxScrolling mode="virtual" />
            <DxEditing :allow-updating="true" :allow-deleting="true" :allow-adding="true" mode="popup">
                <DxPopup :show-title="true" title="Componentă sumă" :width="540" :height="400" />
                <DxFormPopup :col-count="1">
                    <DxItem data-field="Ordine" />
                    <DxItem data-field="SemnOperatie" />
                    <DxItem data-field="CodVariabilaSalarii" />
                    <DxItem data-field="ContId" />
                    <DxItem data-field="Activa" />
                </DxFormPopup>
            </DxEditing>

            <DxColumn data-field="Ordine" caption="Ordine" :width="80" alignment="center" />
            <DxColumn data-field="SemnOperatie" caption="Semn" :width="80" alignment="center" />
            <DxColumn data-field="CodVariabilaSalarii" caption="Cod variabilă salarii" :min-width="180" />
            <DxColumn data-field="ContId" caption="Cont contabil" :min-width="180">
                <DxLookup :data-source="dsConturi" value-expr="Id" :display-expr="contDisplay" :search-enabled="true" />
            </DxColumn>
            <DxColumn data-field="Activa" caption="Activă" data-type="boolean" :width="80" />
        </DxDataGrid>

        <DxPopup v-model:visible="popupVisible" title="Copiază formulele către angajați specificați" :width="480"
            :height="520" :show-close-button="true" :drag-enabled="true">
            <div class="popup-body">
                <DxDataGrid :data-source="angajati" key-expr="Id" height="420" :show-borders="true"
                    :hover-state-enabled="true" @selection-changed="onSelectionChanged"
                    :selected-row-keys="selectedKeys">
                    <DxSelectionGrid mode="multiple" show-check-boxes-mode="always" />
                    <DxScrolling mode="virtual" />
                    <DxSearchPanel :visible="true" placeholder="Caută angajat…" />
                    <DxColumn data-field="InternalCode" caption="Marca" :width="70" />
                    <DxColumn data-field="NumePrenume" caption="Nume" />
                </DxDataGrid>
                <div class="popup-actions">
                    <DxButton text="Anulează" styling-mode="outlined" @click="popupVisible = false" />
                    <DxButton text="Copiază" type="default" styling-mode="contained" @click="confirmCopiere"
                        :disabled="!selectedKeys.length" />
                </div>
            </div>
        </DxPopup>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import {
    DxDataGrid, DxColumn, DxScrolling, DxSearchPanel, DxEditing, DxLookup, DxPopup, DxForm as DxFormPopup, DxItem,
    DxSelection as DxSelectionGrid
} from 'devextreme-vue/data-grid';
import { DxButton } from 'devextreme-vue/button';
import ODataStore from 'devextreme/data/odata/store';
import DataSource from 'devextreme/data/data_source';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import RU_Pontaj from '@/services/RU/RU_Pontaj';

export default defineComponent({
    components: {
        DxDataGrid, DxColumn, DxScrolling, DxSearchPanel, DxEditing, DxLookup, DxPopup, DxFormPopup, DxItem,
        DxSelectionGrid, DxButton
    },
    props: {
        empId: { type: String, default: null },
        angajati: { type: Array, default: () => [] },
    },
    data() {
        return {
            gridRef: ref(null),
            ds: {} as any,
            dsConturi: {
                store: new ODataStore({
                    url: AppSetting.API_Url_ResurseUmaneOdata + 'CON_Conturi', key: 'Id',
                    beforeSend: (e: any) => { e.headers = { Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') }; }
                }), paginate: true, pageSize: 50, searchExpr: ['Simbol', 'Nume']
            } as any,
            popupVisible: false,
            selectedKeys: [] as string[],
        };
    },
    methods: {
        contDisplay(i: any) { return i ? [i.Simbol, i.Nume].filter(Boolean).join(' - ') : ''; },
        build() {
            // Legacy: formula "Ang. Generic" — stocata pe angajatul generic (Guid.Empty), NU pe angajatul selectat
            const ANGAJAT_GENERIC = '00000000-0000-0000-0000-000000000000';
            this.ds = new DataSource({
                store: new ODataStore({
                    version: 4, url: AppSetting.API_Url_ResurseUmaneOdata + 'SAL_CapitoleComponentaSuma', key: 'Id',
                    keyType: { Id: 'Guid' }, fieldTypes: { Id: 'Guid', AngajatId: 'Guid', ContId: 'Guid' },
                    beforeSend: (e: any) => { e.headers = { Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') }; },
                    onInserting: (v: any) => { v.AngajatId = ANGAJAT_GENERIC; },
                }),
                filter: ['AngajatId', '=', ANGAJAT_GENERIC],
            });
        },
        onContextMenu(e: any) {
            if (e.row?.rowType !== 'data' && e.target !== 'content') return;
            e.items = e.items || [];
            e.items.push({
                text: 'Copiază formulele către angajați specificați',
                onItemClick: () => { this.selectedKeys = []; this.popupVisible = true; },
            });
        },
        onSelectionChanged(e: any) {
            this.selectedKeys = e.selectedRowKeys;
        },
        async confirmCopiere() {
            if (!this.selectedKeys.length) return;
            try {
                await RU_Pontaj.copiazaFormule('00000000-0000-0000-0000-000000000000', this.selectedKeys);
                notify('Formulele au fost copiate.', 'success', 2500);
                this.popupVisible = false;
            } catch (e) { console.error(e); notify('Eroare la copierea formulelor!', 'error', 3000); }
        },
    },
    mounted() { this.build(); },
});
</script>
<style scoped>
.cap-body { height: 100%; }
.popup-body { display: flex; flex-direction: column; gap: 12px; height: 100%; }
.popup-actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 8px; }
</style>
